import React, { useMemo, useState } from 'react';
import { Box, Typography } from '@mui/material';
import AsyncCustomSelect from '../../../../../../ui/custom_react_select/async_select';
import { EmployeeUser } from '../../../../../../utils/types/admin_types';
import { SelectOptions } from '../../../../../../utils/types/react_select_types';

interface ContributorSelectWithDisplayProps {
  employees: EmployeeUser[];
  editable?: boolean;
  label?: string;
  value?: SelectOptions[];
  onChange?: (selected: SelectOptions[]) => void;
}

export const ContributorSelectWithDisplay: React.FC<ContributorSelectWithDisplayProps> = ({
  employees = [],
  editable = true,
  label = 'Contributors',
  value,
  onChange,
}) => {
  const contributorOptions = useMemo<SelectOptions[]>(
    () =>
      employees.map((employee) => ({
        value: employee.id,
        label: `${employee.user.firstName} ${employee.user.lastName}`,
      })),
    [employees],
  );

  const [selectedContributors, setSelectedContributors] = useState<
    SelectOptions[]
  >([]);

  const handleChange = (selected: SelectOptions[] | null) => {
    const selection = selected ?? [];
    setSelectedContributors(selection);
    if (onChange) onChange(selection);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <Typography variant="caption" sx={{ fontWeight: 600, mb: 0.5, color: 'text.primary' }}>
        {label}
      </Typography>
      <AsyncCustomSelect
        name="contributors"
        value={value ?? selectedContributors}
        defaultOptions={contributorOptions}
        onChange={handleChange}
        loadOptions={(
          input: string,
          callback: (options: SelectOptions[]) => void,
        ) =>
          callback(
            contributorOptions.filter((option) =>
              option.label.toLowerCase().includes((input || '').toLowerCase()),
            ),
          )
        }
        isMulti
        disabled={!editable}
        placeholder="Select contributors"
      />
    </Box>
  );
};
